module.exports = __webpack_public_path__ + "img/btn-yellow.92f6d00f.png";